import { useImmerAtom } from 'jotai-immer';
import { tableViewAtom, tableFiltersAtom, tableStatsAtom, groupsDataAtom } from '../mfr_restrictions_list_atoms';
import { MFRRestrictionsDataHook } from '../mfr_restrictions_list_types';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const useMFRRestrictionsListData = (): MFRRestrictionsDataHook => {
    const [view] = useImmerAtom(tableViewAtom);
    const [filters] = useImmerAtom(tableFiltersAtom);
    const [stats, setStats] = useImmerAtom(tableStatsAtom);
    const [data] = useImmerAtom(groupsDataAtom);

    const { items } = useTableData({
        view,
        filters,
        stats,
        data,
        setStats,
    });

    return { items };
};
